import React from "react"
import { FaLinkedinIn,
        FaTwitter,
        FaPinterest,
        FaInstagram,
        FaFacebook,
        FaYoutube,
        FaVimeo } from "react-icons/fa"

export default [
  {
    icon: <FaLinkedinIn />,
    url: "http://www.linkedin.com/company/forms-surfaces",
    name: "LinkedIn",
  },
  {
    icon: <FaTwitter />,
    url: "http://twitter.com/#!/forms_surfaces",
    name: "Twitter",
  },
  {
    icon: <FaPinterest />,
    url: "http://pinterest.com/forms_surfaces/",
    name: "Pinterest",
  },
  {
    icon: <FaInstagram />,
    url: "http://instagram.com/forms_surfaces",
    name: "Instagram",
  },
  {
    icon: <FaFacebook />,
    url: "http://www.facebook.com/pages/FormsSurfaces/297576853590206",
    name: "Facebook",
  },
  {
    icon: <FaYoutube />,
    url: "https://www.youtube.com/forms-surfaces",
    name: "YouTube",
  },
  {
    icon: <FaVimeo />,
    url: "https://vimeo.com/formsandsurfaces",
    name: "Vimeo",
  },
]
